module.exports = __webpack_public_path__ + "static/media/heart.f6713ec2.svg";